import React,{ useState } from "react";
import "./SelectCoverVideo.scss";

import CoverFromPlayer from "./CoverFromPlayer";
import CoverFromUpload from "./coverFromUpload";
import {Button} from "../../../../components/Button";

const SelectCoverVideo = ({
                              media = {}
                          }) => {

    const [selectChoice, setSelectChoice] = useState(0);

    let arrayChoice = [
        <div className={"choice"}>
            <Button size={"small"}
                    btnStyle={"primary-reverse"}
                    onClick={() => setSelectChoice(1)}
                    content={"Utiliser une image depuis votre vidéo"}/>
            <Button size={"small"}
                    btnStyle={"primary-reverse"}
                    onClick={() => setSelectChoice(2)}
                    content={"Utiliser une image personnalisée"}/>
        </div>,
        <CoverFromPlayer media={media} goBack={()=>setSelectChoice(0)} handleClose={()=>setSelectChoice(0)} />,
        <CoverFromUpload mediaId={media._id} handleClose={()=>setSelectChoice(0)} uploadPath={"/medias/upload-cover-video"} />
    ];

    return (
        <div id={"select-cover-video"}>
            {arrayChoice[selectChoice]}
        </div>
    )
}


export default SelectCoverVideo;